/**
 * Insta NFT × Shopify — storefront cart helper
 *
 * Hydrates window.instaNftCheckoutData.shopify from GET /cart.js so checkout JS
 * can POST /app/transaction/payment/purchase with:
 *   { shopify: { cart_token, draft_order_id, shop, currency, items, total_price } }
 */
(function () {
  function moneyFromCents(cents) {
    var n = Number(cents);
    if (isNaN(n)) return 0;
    return Math.round(n) / 100;
  }

  function variantGid(variantId) {
    var s = String(variantId || '');
    if (s.indexOf('gid://') === 0) return s;
    return 'gid://shopify/ProductVariant/' + s;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to load cart (' + res.status + ')');
      return res.json();
    });
  }

  function mapCartItems(cart) {
    var items = cart && cart.items ? cart.items : [];
    return items.map(function (item) {
      return {
        variant_id: item.variant_id,
        variant_gid: variantGid(item.variant_id),
        quantity: item.quantity,
        title: item.title || item.product_title,
        sku: item.sku || '',
        price: item.price,
        line_price: item.line_price,
        original_line_price: item.original_line_price,
        properties: item.properties || {},
        requires_shipping: !!item.requires_shipping,
        product_id: item.product_id,
        key: item.key
      };
    });
  }

  var DRAFT_SESSION_KEY = 'inc_shopify_nft_checkout';

  function readDraftSession() {
    try {
      var raw = localStorage.getItem(DRAFT_SESSION_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function hydrateCheckoutData(cart) {
    if (!window.instaNftCheckoutData) window.instaNftCheckoutData = {};
    var checkout = window.instaNftCheckoutData;
    var prev = checkout.shopify || {};
    checkout.site_type = checkout.site_type || 'shopify';
    checkout.cart_total = moneyFromCents(cart.total_price);

    var session = readDraftSession() || {};
    var draft_order_id = '';
    if (
      session.draft_order_id &&
      (!session.cart_token || session.cart_token === cart.token)
    ) {
      draft_order_id = session.draft_order_id;
    } else if (prev.draft_order_id && prev.cart_token === cart.token) {
      draft_order_id = prev.draft_order_id;
    }

    checkout.shopify = {
      cart_token: cart.token,
      draft_order_id: draft_order_id,
      shop: prev.shop || '',
      currency: cart.currency || prev.currency || 'USD',
      items: mapCartItems(cart),
      total_price: cart.total_price
    };
  }

  window.incShopifyFetchCart = fetchCart;

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart()
      .then(hydrateCheckoutData)
      .catch(function (err) {
        if (window.console && console.error) console.error(err);
      });
  });
})();
